<template>
  <div
    class="fixed top-0 left-0 z-20 h-18 w-full flex items-center bg-white th-topbar th-shadow-bottom px-5 md:px-10"
  >
    <template class="" v-if="searchMobileVisible">
      <input
        v-model="searchCourse"
        placeholder="Cari Course..."
        type="text"
        class="w-full mr-5 border-2 border-gray-300 rounded-sm py-2 px-4 focus:border-primary"
      />
      <div class="ml-auto" @click.prevent="onSearchMobile">
        <svg
          class="w-6 h-6 text-darkblue"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M6 18L18 6M6 6l12 12"
          ></path>
        </svg>
      </div>
    </template>
    <template v-else>
      <div class="flex items-center">
        <div
          class="mr-5 hidden md:block"
          @click.prevent="burgerMenuAction('sidebar')"
        >
          <burger-menu-icon class="th-hover-pointer" />
        </div>
        <router-link to="/" @click.native="changeMenu('Utama')">
          <img class="h-9 lg:h-10 p-1" src="/img/Logo.png" alt="tholhah-tv" />
        </router-link>
      </div>
      <input
        v-model="searchCourse"
        placeholder="Cari Course..."
        type="text"
        class="hidden md:block ml-10 w-2/5 border-2 border-gray-300 rounded-sm py-2 px-4 focus:border-primary"
      />
      <div class="ml-auto flex items-center gap-5">
        <div @click.prevent="onSearchMobile">
          <search-icon class="th-hover-pointer block md:hidden" />
        </div>
        <va-dropdown id="cart-dropdown" class="border-r-0 md:border-r md:pr-5">
          <div slot="trigger">
            <shopping-cart-icon class="th-hover-pointer" />
          </div>
          <va-card class="w-60 z-10">
            <template v-if="!carts.length">
              <div class="no-cart-list">Belum Ada Pembelian</div>
            </template>
            <template v-else>
              <div class="list-cart">
                <CardCart v-for="(cart, i) in carts" :key="i" :meta="cart" />
                <div
                  v-if="carts.length > 5"
                  class="text-center"
                  style="font-size: 12px"
                >
                  dan {{ carts.length - 5 }} course lainnya
                </div>
              </div>
              <hr />
              <div class="total-cart-action">
                <div class="py-2 font-bold text-gray-900">
                  Total: {{ thousandPrice(totalCartPrice) }}
                </div>
                <router-link
                  :to="{ name: 'Keranjang' }"
                  @click.native="changeMenu('')"
                >
                  <va-button
                    type="primary"
                    class="total-cart-action-button"
                    block
                    >Lihat Keranjang</va-button
                  >
                </router-link>
              </div>
            </template>
          </va-card>
        </va-dropdown>
        <template v-if="!sessionId">
          <div class="hidden lg:flex">
            <router-link :to="{ name: 'Masuk' }">
              <div class="mr-3">
                <va-button type="subtle">Masuk Ke Akun Anda</va-button>
              </div>
            </router-link>
            <router-link :to="{ name: 'Daftar' }">
              <va-button type="primary">Buat Akun</va-button>
            </router-link>
          </div>
          <div
            class="block lg:hidden"
            @click.prevent="burgerMenuAction('aside')"
          >
            <burger-menu-icon class="th-hover-pointer" />
          </div>
          <va-aside placement="right" ref="moreAside">
            <div class="flex flex-col lg:hidden p-4">
              <router-link :to="{ name: 'Masuk' }">
                <div class="mb-2">
                  <va-button type="subtle" block>Masuk Ke Akun Anda</va-button>
                </div>
              </router-link>
              <router-link :to="{ name: 'Daftar' }">
                <va-button type="primary" block>Buat Akun</va-button>
              </router-link>
            </div>
          </va-aside>
        </template>

        <va-dropdown v-else id="menu-dropdown">
          <!-- <img slot="trigger" width="32" height="32" src="/img/female-profile.png" alt="profile"> -->
          <div slot="trigger" class="th-hover-pointer">
            <img
              v-if="user.profilePicture"
              width="32"
              height="32"
              :src="backendUrl + user.profilePicture"
              class="rounded-full w-15 h-15"
              :alt="user.name"
            />
            <avatar
              v-else
              :size="32"
              :username="user.name"
            ></avatar>
          </div>
          <va-card>
            <div class="th-topbar-account-profile">
              <img
                v-if="user.profilePicture"
                width="32"
                :src="backendUrl + user.profilePicture"
                class="rounded-full w-15 h-15"
                :alt="user.name"
              />
              <avatar
                v-else
                :size="32"
                :username="user.name"
              ></avatar>
              <div class="mr-2">
              </div>
              <div>
                <div>{{ user.name || "Nurul Jannah" }}</div>
                <div style="font-size: 12px; font-weight: 300">
                  {{ user.email }}
                </div>
              </div>
            </div>
            <hr />
            <div class="th-topbar-account-action">
              <router-link
                :to="{ name: 'Akun', query: { menu: 'profil' } }"
                @click.native="changeMenu('')"
              >
                <div class="action-edit">Edit Profil</div>
              </router-link>
              <router-link
                :to="{ name: 'Akun', query: { menu: 'pengaturan-akun' } }"
                @click.native="changeMenu('')"
              >
                <div class="action-account">Pengaturan Akun</div>
              </router-link>
              <router-link
                :to="{ name: 'Akun', query: { menu: 'riwayat-pembelian' } }"
                @click.native="changeMenu('')"
              >
                <div class="action-history">Riwayat Pembelian</div>
              </router-link>
            </div>
            <hr />
            <router-link :to="{ name: 'Masuk' }" @click.native="logout">
              <div class="th-topbar-account-logout">Keluar</div>
            </router-link>
          </va-card>
        </va-dropdown>
      </div>
    </template>
  </div>
</template>

<script>
import thousandPrice from '@/helpers/thousandPrice'
import Avatar from 'vue-avatar'
const BurgerMenuIcon = () => import('@/components/Icon/BurgerMenu.vue')
const ShoppingCartIcon = () => import('@/components/Icon/ShoppingCart.vue')
const SearchIcon = () => import('@/components/Icon/Search.vue')
const CardCart = () => import('@/components/App/CardCart')
export default {
  components: {
    BurgerMenuIcon,
    ShoppingCartIcon,
    SearchIcon,
    Avatar,
    CardCart,
  },
  data() {
    return {
      thousandPrice,
      searchMobileVisible: false,
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  methods: {
    onSearchMobile() {
      this.searchMobileVisible = !this.searchMobileVisible
      console.log(this.searchMobileVisible)
    },
    burgerMenuAction(type) {
      if (type === 'sidebar') {
        this.$store.commit('SET_STATE', { sidebarIsExpanded: !this.sidebarIsExpanded })
      } else if (type === 'aside') {
        this.$refs.moreAside.open()
      }
    },
    goTo(routeName) {
      if (routeName === this.$route.name) return
      this.$store.commit('SET_STATE', { currentMenu: '' })
      this.$router.push({ name: routeName })
    },
    logout() { this.$store.dispatch('user/LOGOUT') },
    changeMenu(menuName) {
      // const divCartDropdown = document.getElementById('cart-dropdown')
      // divCartDropdown.classList.remove('va-dropdown-selected')
      // const divDropdown = divCartDropdown.getElementsByClassName('va-dropdown-menu')[0]
      // divDropdown.style.display = 'none'
      // divDropdown.classList.remove('position-right-bottom')
      this.$store.commit('SET_STATE', { currentMenu: menuName })
    },
  },
  computed: {
    sidebarIsExpanded() { return this.$store.state.sidebarIsExpanded },
    sessionId() { return this.$store.state.user.sessionId },
    carts() { return this.$store.state.cart.carts },
    totalCartPrice() { return this.$store.getters['cart/totalCartPrice'] },
    user() { return this.$cookies.get('user') },
    // searchCourse: {
    // get: () => {
    //   return this.$store.state.searchCourse
    // },
    // set: (val) => {
    //   this.$store.commit('SET_STATE', {
    //     searchCourse: val,
    //   })
    // },
    // },
    searchCourse: {
      get: function () {
        return this.$store.state.searchCourse
      },
      set: function (val) {
        if (this.$route.name !== 'Temukan') {
          this.$router.push({ name: 'Temukan', query: { name: val } })
        }
        this.$store.commit('SET_STATE', {
          searchCourse: val,
        })
      },
    },
  },
  created() {
    console.log(this.user)
    // const carts = [{ key: 1, imgSrc: '/img/thumbnail/4.png', title: 'Kajian Kitab Tadzkiatun Nafs', by: 'Zain Abu Kautsar', price: 159000 }]
    // this.$store.commit('cart/SET_STATE', { carts })
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";
#menu-dropdown > .va-dropdown-menu {
  min-width: 250px!important;
}
.th-topbar {
  .va-dropdown-menu {
    background-color: $white;
    box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.2) !important;
    border: 1px solid $border;
    border-radius: $border-radius;
    padding: 0;
    left: auto !important;
    right: 0 !important;

    // &.position-right-bottom {
    //   left: auto!important;
    //   right: 0!important;
    // }

    .va-card-body {
      padding: 0 !important;
      .list-cart,
      .total-cart-action,
      .no-cart-list {
        padding: 12px 14px;
      }

      hr {
        margin: 0;
      }
    }

    .total-cart-action {
      &-total {
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 10px;
      }

      &-button {
      }
    }
  }

  &-account {
    &-profile,
    &-action,
    &-logout {
    }

    &-profile {
      display: flex;
      padding: 14px 14px 12px;
      align-items: center;

      .profile {
        &-image {
          margin-right: 7px;
        }
      }
    }

    &-action {
      .action {
        // a {
        //   &:hover {
        //     background-color: $primary;
        //   }
        // }
        &-account,
        &-edit,
        &-history {
          color: $black;
          margin: 0 6px;
          padding: 0 7px;
          padding-bottom: 6px;
          padding-top: 6px;
          &:hover {
            background-color: $primary;
            color: $white;
            border-radius: $border-radius;
          }
        }
        &-account,
        &-edit {
          // margin-bottom: 8px
        }

        &-edit {
          margin-top: 6px;
        }

        &-history {
          margin-bottom: 6px;
        }
      }
    }

    &-logout {
      margin: 6px;
      padding: 6px 7px;
      color: $black;
      &:hover {
        background-color: $primary;
        color: $white;
        border-radius: $border-radius;
      }
    }
  }
}
</style>
